var render = function render(){var _vm=this,_c=_vm._self._c;return _c('select',{on:{"change":function($event){return _vm.$emit('input', $event.target.value)}}},_vm._l((_vm.options),function(option,i){return _c('option',{key:i,domProps:{"value":option,"selected":option == _vm.value}},[_vm._v(" "+_vm._s(option)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }